module.exports = __webpack_public_path__ + "fonts/ethnocen-webfont.58f8f1cb.woff2";